import { Map } from "immutable";
import Widget from "views/logic/widgets/Widget";
import isDeepEqual from "stores/isDeepEqual";
import isEqualForSearch from "views/stores/isEqualForSearch";
import DataLakeWidgetConfig from "data-lake/logic/DataLakeWidgetConfig";
const _DataLakeWidget = class _DataLakeWidget extends Widget {
  constructor(id, config, timerange, streams = []) {
    super(id, _DataLakeWidget.type, config, void 0, timerange, void 0, streams, void 0, void 0);
  }
  // eslint-disable-next-line class-methods-use-this
  get isExportable() {
    return true;
  }
  static fromJSON(value) {
    const { id, config, timerange, streams } = value;
    return new _DataLakeWidget(id, DataLakeWidgetConfig.fromJSON(config), timerange, streams);
  }
  equals(other) {
    if (other instanceof _DataLakeWidget) {
      return ["id", "config", "timerange", "streams"].every((key) => isDeepEqual(this[key], other[key]));
    }
    return false;
  }
  equalsForSearch(other) {
    if (other instanceof _DataLakeWidget) {
      return ["id", "config", "timerange", "streams"].every((key) => isEqualForSearch(this[key], other[key]));
    }
    return false;
  }
  toBuilder() {
    const { id, config, timerange, streams } = this._value;
    return new Builder(Map({ id, config, timerange, streams }));
  }
  static builder() {
    return new Builder();
  }
};
_DataLakeWidget.type = "data-lake";
_DataLakeWidget.defaultTitle = "Untitled Log View";
let DataLakeWidget = _DataLakeWidget;
export {
  DataLakeWidget as default
};
class Builder extends Widget.Builder {
  build() {
    const { id, config, timerange, streams } = this.value.toObject();
    return new DataLakeWidget(id, config, timerange, streams);
  }
}
